import React from 'react';
import { ReactComponent as MenuIcon } from '../../../images/menu-01.svg';
import { useAppDispatch } from '../../../hooks/storeHooks';
import { setNavMenuTap } from '../NavigationSlice';
import useWindowWidth from '../../../hooks/useWindowWidth';

const MenuNavIcon: React.FC = () => {
  const dispatch = useAppDispatch();
  const windowWidth = useWindowWidth();

  const handleMenuIconClick = () => dispatch(setNavMenuTap(true));

  if (windowWidth <= 1024) {
    return <MenuIcon onClick={handleMenuIconClick} style={{ cursor: 'pointer' }} />;
  }
  return null;
};

export default MenuNavIcon;
